export default {
    token: localStorage.getItem('token') || null,
    user: {},
    portal_count: 0,
    continue: '', //Where to redirect after login was required.,
    notifications: [],
    show_terms: false,
    stripe_pk: '',
    billing_window: null,
    applicant_uploads: []
}